import { CalendarBlank, Phone, EnvelopeSimple } from "@phosphor-icons/react";

const today = new Date().toISOString().slice(0, 10);
const fmt = (iso) => (iso ? new Date(iso + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" }) : null);
const daysUntil = (iso) => Math.round((new Date(iso + "T00:00:00") - new Date(today + "T00:00:00")) / 86400000);

// One line per current assignment: where, since when, when it's expected to wrap, and which rep to talk to.
export function WorkerAvailability({ assignments = [], compact = false, testId }) {
  if (!assignments.length) return <span className="text-xs text-slate-400">Not assigned</span>;
  return (
    <div className={`space-y-1.5 ${compact ? "" : "min-w-[220px]"}`} data-testid={testId}>
      {assignments.map((a, i) => {
        const d = a.expected_end_date ? daysUntil(a.expected_end_date) : null;
        const soon = d !== null && d <= 21;
        return (
          <div key={i} className="text-xs leading-snug" data-testid={testId ? `${testId}-${i}` : undefined}>
            <div className="font-semibold text-slate-800">{a.project_name}{a.client_name && <span className="font-normal text-slate-500"> · {a.client_name}</span>}</div>
            <div className="flex flex-wrap items-center gap-x-2 text-slate-600">
              {a.start_date && <span>since {fmt(a.start_date)}</span>}
              {a.expected_end_date
                ? <span className={`inline-flex items-center gap-1 font-semibold ${d < 0 ? "text-slate-500" : soon ? "text-emerald-700" : "text-amber-700"}`}>
                    <CalendarBlank size={11} weight="bold" /> {d < 0 ? `was due to end ${fmt(a.expected_end_date)}` : d === 0 ? "ends today" : `ends ~${fmt(a.expected_end_date)} (${d}d)`}
                  </span>
                : <span className="text-rose-700 font-semibold">no end date</span>}
            </div>
            <div className="text-slate-600">
              {a.is_mine ? <span className="text-emerald-700 font-semibold">your project</span>
                : a.rep_name
                ? <span>rep: <b>{a.rep_name}</b>
                    {a.rep_phone && <a href={`tel:${a.rep_phone}`} className="ml-1.5 inline-flex align-middle text-slate-500 hover:text-emerald-700" title={a.rep_phone}><Phone size={11} weight="bold" /></a>}
                    {a.rep_email && <a href={`mailto:${a.rep_email}`} className="ml-1 inline-flex align-middle text-slate-500 hover:text-emerald-700" title={a.rep_email}><EnvelopeSimple size={11} weight="bold" /></a>}
                  </span>
                : <span className="text-slate-500">office-managed — ask admin</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
